import ApiRequest from "../util/ApiRequest";

export default class Voucher {
    static checkByCode = async (code) => {
        return await ApiRequest.set(`v1/voucher/check/${code}`,"GET");
    }
}
